import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ClientTrialById, TENANTSINTERFACE, TrialBooking, } from '@fitness-force/models';
import { DataGridComponent,NoComponentComponent, NoTrialHistoryComponent, } from '@fitness-force/grid';
import {  CreateOpportunityComponent,} from '@fitness-force/crm'
import {
  ChangeClientRepBulkComponent, ClientRepresentativeComponent, 
  ProspectInfoComponent,
  ProspectSourceComponent, SharedModule, 
  StaffInfoComponent, 
  TaskCreateComponent,
  TimeFormattedComponent,
  TrialUsedComponent} from '@fitness-force/shared';
import { Store } from '@ngrx/store';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { SelectButtonModule } from 'primeng/selectbutton';
import { StyleClassModule } from 'primeng/styleclass';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { TENANTS_INFO, ROUTER_STATE, STAGE_MASTER_STATE } from '../../../state/app.state';
import { AuthSevices, ClientExportService, ClientTrialService, ReportFilterService, TimeconversionService, ToastMessageService, TrialService } from '@fitness-force/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { DividerModule } from 'primeng/divider';
import { TranslateService } from '@ngx-translate/core';
import { DrawerModule } from 'primeng/drawer';
import { ClientInfoSidebarComponent } from '@fitness-force/core';
import { FileSaverService } from 'ngx-filesaver';
import { AppErrors, NotFoundError } from '@fitness-force/errors';

import { PopoverModule } from 'primeng/popover';
import { DatePickerModule } from 'primeng/datepicker';
import { DateFormatedComponent } from 'libs/grid-utility/src/lib/date-formated/date-formated.component';
import { TrialType } from '@fitness-force/enum';
import { DialogModule } from 'primeng/dialog';
import { ProspectFormComponent } from 'libs/core/src/lib/prospect-form/prospect-form.component';
const EXCEL_EXTENSION = 'xlsx';


@Component({
  selector: 'fitness-force-prospect-list',
  templateUrl: './trial-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    DataGridComponent,
    StyleClassModule,
    SelectModule,
    ButtonModule,
    RippleModule,
    StyleClassModule,
    SelectButtonModule,
    MultiSelectModule,
    InputTextModule,
    ButtonModule,
    TaskCreateComponent,
    BreadcrumbModule,
    DividerModule,
    CreateOpportunityComponent,
    DrawerModule,
    PopoverModule,
    ClientInfoSidebarComponent,
    ChangeClientRepBulkComponent,
    SharedModule,
    DatePickerModule,
    DialogModule,
    ProspectFormComponent
]
})

export class TrialListComponent implements OnInit {
  currentUrl = ''
  showToolbar = false;
  getAccessTenantList$: Observable<any> | any;
  tenantId = 0;
  columns: any = new BehaviorSubject([])
  tableData: any = new BehaviorSubject([])
  selectedClient: any = new Map()
  clients: any = new BehaviorSubject([])
  tags: any[] = [];
  selectedTags: any[] | undefined;
  showCalendar = false;
  taskCategory: any[] = []
  selectedTaskCategory: { name: string; } | undefined;
  toggleCreateSmsDialog$: any = new BehaviorSubject<boolean | null>(false)
  allClients$ = new BehaviorSubject<any>([])
  calendarInput: Date | undefined;
  staffSelected: Array<number> = [];
  showTaskCreate = false;
  items: any[] = [];
  products: any[] = [];
  totalItems: any = new BehaviorSubject('')
  activefilters: any[] = [];
  selectedFilter: { name: string; } | undefined;
  showCreateOpportunityPopup: Observable<boolean> | any = false;
  selectedStage: UntypedFormControl = new UntypedFormControl('');
  prospectParams: any = new Map()
  showBulkActionBar = false;
  showCreateProspectPopup: Observable<boolean> = of(false);
  selectAllProspectData = new BehaviorSubject(false)
  totalRecordLength = new BehaviorSubject({ totalPage: 10, totalItems: 10, currentPage: 0 })
  tableRecord: any = []
  emptyStateComponent$ = new BehaviorSubject<any>(NoComponentComponent)
  loading = false;
  selectedStaffIds: any = [];
  showClientSidebar = false;
  activeClientId = 0;
  opportunityStages!: any;
  exporting = new BehaviorSubject(false);
  customFilterForm: UntypedFormGroup = new UntypedFormGroup({});
  listOpportunityStage$?: Observable<any>;
  showChangeSalesRep: boolean = false;
  trialTypes: any[] = [
    {key: "DaysBased", value: TrialType.DaysBased},
    {key: "ClassBased", value: TrialType.ClassBased},
    {key: "ApptBased", value: TrialType.ApptBased}
  ];
  trialStatus: any[] = [
    {key: "Active", value: 'Active'},
    {key: "Inactive", value: 'Inactive'},
    {key: "Completed", value: 'Completed'},
    {key: "Created", value: 'Created'}
  ];
  showTrialHistory = new BehaviorSubject<boolean>(false);
  trialHistoryData$ = new BehaviorSubject<TrialBooking[]>([]);
  trialHistoryDataTablecolumns$ = new BehaviorSubject<any[]>([]);
  clientTrial: ClientTrialById | null;
  showSkeleton: boolean;
  selecallTrialData: boolean = false;
  emptyStateComponentForHistory$ = new BehaviorSubject<any>(NoTrialHistoryComponent);

  constructor(private router: Router,
    private store: Store,
    private trialService: TrialService,
    private authService: AuthSevices,
    private clientExportService: ClientExportService,
    private reportFilterService: ReportFilterService,
    private _FileSaverService: FileSaverService,
    private fb: UntypedFormBuilder,
    private timeService: TimeconversionService,
    public toastMessageService:ToastMessageService,
    public cd: ChangeDetectorRef,
    private translate: TranslateService,
    private clientTrialService: ClientTrialService
  ) {
  }

  ngOnInit(): void {
    this.componentInit();
  }

  componentInit() {
    this.selectedStaffIds = JSON.parse(localStorage.getItem("PROSPECT_STAFF_LIST") || '[]');
    if (this.selectedStaffIds.length == 0) {
      this.selectedStaffIds.push(parseInt(this.authService.currentUserDetails()?.Id));
    }
    this.router.events.subscribe((data: any) => {
      this.currentUrl = data.url
    })
    this.getAccessTenantList$ = this.store.select(TENANTS_INFO);
    this.store.select(ROUTER_STATE).subscribe((rd) => {
      this.currentUrl = rd.url
    })
    this.getAccessTenantList$.subscribe((tenant: TENANTSINTERFACE) => {
      this.tenantId = tenant.selected_tenant.id
      if (this.tenantId > 0) {
        this.store.dispatch({ type: 'ROUTER_GO' })
        //this.prospectParams.set('trial_type', { name: "trial_type", value: "" })
        this.prospectParams.set('PageNumber', { name: 'PageNumber', value: 1 })
        this.prospectParams.set('PageSize', { name: 'PageSize', value: 10 })
        this.totalRecordLength.next({ totalPage: 10, totalItems: 10, currentPage: 0 })
        this.getAllClientTrials();
        this.getBoardList();
      }
    });

    this.customFilterForm = this.fb.group({
      type: [''],
      status: ['']
    });
  }

  getBoardList() {
    this.store.select(STAGE_MASTER_STATE).subscribe((data: any) => {
      this.opportunityStages = data;
    });
  }


  // @HostListener('window:visibilitychange', ['$event'])
  // VisibilityChange(event: any): void {
  //   if (event.target.visibilityState.toLowerCase() == 'visible')
  //     this.getAllClientTrials();
  // }

  handleEvent(e: any) {
    if (e.selection) {
      this.selectedClient.set(e.data.data.index, e.data.data)
      this.showBulkActionBar = true;
    }
    else {
      this.selectedClient.delete(e.data.data.index)
      if (this.selectedClient.size > 0) {
        this.showBulkActionBar = true
      } else {
        this.showBulkActionBar = false
      }
    }
    this.allClients$.next(this.getSelectedClientData)
  }

  handleSelectAll(selection: any) {
    if (selection.checked) {
      this.showBulkActionBar = true;
      this.tableRecord.forEach((value: any, index: any) => {
        if (this.rowSelectableFunction(value)) {
          this.selectedClient.set(index, value);
        }
      });
    } else {
      this.showBulkActionBar = false
      this.selectedClient.clear();
    }
    this.allClients$.next(this.getSelectedClientData)
  }

  toggleCreateSmsDialog() {
    this.toggleCreateSmsDialog$.next(true)
  }

  selectedStaffsData(staffs: any) {
    this.selectedStaffIds = [];
    staffs.forEach((s: any) => {
      this.selectedStaffIds.push(s.id)
    });
    localStorage.setItem("PROSPECT_STAFF_LIST", JSON.stringify(this.selectedStaffIds));
    this.getAllClientTrials();
  }

  closeCreateSmsDialog() {
    this.toggleCreateSmsDialog$.next(false)
  }

  getAllClientTrials() {
    this.loading = true;
    this.trialService.getClientTrials(this.tenantId, this.getProspectParams).subscribe((res: any) => {
      this.loading = false;
      this.emptyStateComponent$.next(NoComponentComponent)
      this.gettableRecord(res.items ? res.items : [])
      this.tableData.next(res.items ? res.items : [])
      this.totalRecordLength.next({ totalPage: res.total_pages, totalItems: res.total_items, currentPage: res.current_page })
      this.totalItems.next(res.total_items)
      this.GetTableColumns();
      this.selectAllProspectData.next(true)
    })
  }

  GetTableColumns() {
    this.translate
      .get([
        'Shared.PROSPECT.COLUMNS.MEMBER_NAME',
        'Shared.PROSPECT.COLUMNS.CLIENT_REP',
        'Shared.PROSPECT.COLUMNS.CHANNEL',
        'Shared.PROSPECT.COLUMNS.SOURCE',
        'Shared.PROSPECT.COLUMNS.TRIAL_START_DATE',
        'Shared.PROSPECT.COLUMNS.TRIAL_END_DATE',
        'Shared.PROSPECT.COLUMNS.TRIAL_OWNER',
        'Shared.PROSPECT.COLUMNS.TRIAL_SESSION'
  ])
      .subscribe((translations) => {
        this.TableColumnsTransalation(translations);
      });
  }

  TableColumnsTransalation(translations: any) {
    this.columns.next([
      {
        title: translations['Shared.PROSPECT.COLUMNS.MEMBER_NAME'],
        classes: ' py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'full_name',
        type: 'component',
        data: { name: ProspectInfoComponent }
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.CHANNEL'],
        classes: '  py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'channel',
        type: 'default',
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.SOURCE'],
        classes: '  py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'source',
        type: 'component',
        data: { name: ProspectSourceComponent }
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.CLIENT_REP'],
        classes: ' relative  py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'client_representative_id',
        type: 'component',
        data: { name: ClientRepresentativeComponent }
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.TRIAL_START_DATE'],
        classes: ' py-2 text-600 white-space-nowrap',
        dataProperty: 'start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'start_date', format: 'defaultformat', applytimezone: true },
        },
      },
      {
        title:  translations['Shared.PROSPECT.COLUMNS.TRIAL_END_DATE'],
        classes: ' py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'end_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'end_date', format: 'defaultformat', applytimezone: true },
        },
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.TRIAL_OWNER'],
        classes: ' relative  py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'owner_id',
        type: 'component',
        data: { name: ClientRepresentativeComponent }
      },
      {
        title: translations['Shared.PROSPECT.COLUMNS.TRIAL_SESSION'],
        classes: '  py-2 text-600 white-space-nowrap',
        sortable: true,
        filterable: true,
        dataProperty: 'total_used_trials',
        type: 'component',
        data: { name: TrialUsedComponent,
          additionData: true,
          aData: { used_key: 'total_used_trials', total_key: 'max_trial_class' },
         },
      }
      // {
      //   title: '',
      //   classes: '  py-2 text-600 white-space-nowrap',
      //   sortable: true,
      //   filterable: true,
      //   dataProperty: null,
      //   type: 'component',
      //   data: { name: ProspectListActionsComponent }
      // }
    ])
  }


  gettableRecord(items: any) {
    return this.tableRecord = items
  }

  fetchNextSetData(e: any) {
    this.prospectParams.set('PageNumber', { name: 'PageNumber', value: e.pn })
    this.prospectParams.set('PageSize', { name: 'PageSize', value: e.ps })
    this.gettableRecord([]);
    this.selectedClient.clear()
    this.showBulkActionBar = false
    this.getAllClientTrials()
  }

  clearFilterBySource() {
    if (this.prospectParams.has('source')) {
      this.prospectParams.delete('source')
    }
    this.getAllClientTrials()
  }

  

  get getSelectedRepresetativeIds(): Array<any> {
    const values: any = []
    this.selectedStaffIds.forEach((elm: any) => {
      values.push({ name: "client_representative_id", value: elm })
    });
    return values;
  }

  filterListByStage(event: any) {
    if (event.value && event.value.id) {
      this.prospectParams.set('opp_stage_master_id', { name: "opp_stage_master_id", value: event.value.id })
      this.getAllClientTrials();
    } else {
      this.prospectParams.delete('opp_stage_master_id');
      this.getAllClientTrials()
    }

  }

  hideOpportunity(event: any) {
    this.showCreateOpportunityPopup = false;
  }

  hidePopup() {
    this.showCreateProspectPopup = of(false);
  }

  OpenPopup() {
    this.clients.next(this.getSelectedClientData)
    this.showCreateProspectPopup = of(true);
  }

  HideTaskCreate() {
    this.showTaskCreate = false
  }

  rowSelectableFunction = (data: any) => {
    // Your condition here, for example:
    return data.latest_createdin_tenant_id === this.tenantId;
  };

  newTask() {
    this.clients.next(this.getSelectedClientData)
    this.showTaskCreate = true
  }

  onGridAction(event: any) {
    if (event && event.action == "block" || event.action == "unblock") {
      this.getAllClientTrials()
    } else if (event && event.action == "showProfile") {
      this.showClientSidebar = true;
      this.activeClientId = event?.columnData?.id;
    }
    else if (event && event.action.toLowerCase() == "opentrialhistory") {
      this.getClientTrial(event.columnData.trial_id, event.columnData.id);
    }
    if (event.action == "updated")
      this.getAllClientTrials();
  }

  changeSalesRep() {
    this.clients.next(this.getSelectedClientData);
    this.showChangeSalesRep = true;
  }

  closeSidebar(event: boolean) {
    this.showClientSidebar = event;
  }

  GoToClientDetails(event: any) {
    this.showClientSidebar = true;
    this.activeClientId = event.clientId;
  }

  applyFilter(form: FormGroup) {
    if (form.controls.type.value) {
      this.prospectParams.set('trial_type', { name: 'trial_type', value: form.controls.type.value.value })
    }
    if (form.controls.status.value) {
      this.prospectParams.set('trial_status', { name: 'trial_status', value: form.controls.status.value.value })
    }
    this.getAllClientTrials();
  }

  ExportData() {
    this.prospectParams.delete('trial_type');
    this.prospectParams.delete('trial_status');
    this.prospectParams.delete('PageNumber');
    this.prospectParams.delete('PageSize');
    this.prospectParams.set('PageNumber', { name: 'PageNumber', value: 1 });
    this.prospectParams.set('PageSize', { name: 'PageSize', value: 99999999 });
    const params = this.getProspectParams;
    this.exporting.next(true);
    this.clientExportService.exportClientTrials(params, this.tenantId).subscribe({
      next: (urlObj: { url: string }) => {
        this.reportFilterService.downloadFile(urlObj.url).subscribe(res => {
          this._FileSaverService.save(res, 'client_trials' + new Date().getTime() + "." + EXCEL_EXTENSION);
          this.exporting.next(false);
        });
      },
      error: (error: AppErrors) => {
        this.exporting.next(false);
        this.toastMessageService.showError(error);
        this.cd.detectChanges();
      },
    });
  }


  resetFilter() {
    this.customFilterForm.reset();
    this.prospectParams.delete('trial_tyoe');
    this.prospectParams.delete('trial_status');
    this.prospectParams.delete('PageNumber');
    this.prospectParams.delete('PageSize');
    this.prospectParams.set('PageNumber', { name: 'PageNumber', value: 1 })
    this.prospectParams.set('PageSize', { name: 'PageSize', value: 10 })
    this.totalRecordLength.next({ totalPage: 10, totalItems: 10, currentPage: 0 })
    this.getAllClientTrials()
  }

  closeChangeSaleRepDialog(e: boolean) {
    this.showChangeSalesRep = false;
    this.componentInit();
  }

  getClientTrial(trialId: number, clientId: number) {
    this.clientTrialService.getClientTrial(this.tenantId, clientId, trialId).subscribe({
      next: (response: ClientTrialById) => {
        this.clientTrial = response;
        this.trialHistoryData$.next(this.clientTrial.trial_booking || []);
        this.HistoryColumnsTransalation();
        this.showTrialHistory.next(true);
      },
      error: (error) => {
        this.showTrialHistory.next(true);
        this.showSkeleton = false;
        if (error instanceof NotFoundError) {
          this.translate
            .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
            .subscribe((translation) => {
             this.toastMessageService.showError(translation);
            });
        } else {
          this.translate
            .get('common.errors.SERVER_SIDE.SOMETHING_WRONG')
            .subscribe((translation) => {
              this.toastMessageService.showError(translation);
            });
        }
      },
    });
  }

  HistoryColumnsTransalation() {
    this.translate
      .get([
        'CLIENT_TRIAL.HISTORY_COLUMNS.TIME',
        'CLIENT_TRIAL.HISTORY_COLUMNS.DATE',
        'CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER'
      ])
      .subscribe((translations) => {
        this.GetTrialHistoryColumns(translations);
      });
  }

  GetTrialHistoryColumns(translations: any) {
    let columns = {
      Time: translations['CLIENT_TRIAL.HISTORY_COLUMNS.TIME'],
      Date: translations['CLIENT_TRIAL.HISTORY_COLUMNS.DATE'],
      Trainer: translations['CLIENT_TRIAL.HISTORY_COLUMNS.TRAINER']
    };
    this.trialHistoryDataTablecolumns$.next([
      {
        title: columns.Time,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'end_date',
        type: 'component',
        data: {
          name: TimeFormattedComponent,
          additionData: true,
          fetch_key: 'end_date',
          aData: { keyName: 'end_date', format: 'h:mm a' },
        },
      },
      {
        title: columns.Date,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'start_date',
        type: 'component',
        data: {
          name: DateFormatedComponent,
          additionData: true,
          aData: { KeyName: 'start_date', format: 'd MMM y' },
        },
      },
      {
        title: columns.Trainer,
        classes: 'py-3 white-space-nowrap',
        sortable: true,
        filterable: true,
        selectable: false,
        dataProperty: 'trainer_id',
        type: 'component',
        data: { name: StaffInfoComponent },
      }
  ]);
  }

  CloseTralHistory() {
    this.showTrialHistory.next(false);
  }

  get getProspectParams(): Array<any> {
    return [...this.prospectParams.values()];
  }

  get getSelectedClientData(): Array<any> {
    return [...this.selectedClient.values()];
  }

  get getSelectedClientDataKeyAsId(): Array<any> {
    return [...this.selectedClient.keys()];
  }

  get ClientIds(): number[] {
    return this.getSelectedClientData.map((o: any) => { return o.id });
  }

  get selectedTypeFormControl(): UntypedFormControl {
    return this.customFilterForm.controls.type as UntypedFormControl
  }

  get selectedStatusFormControl(): UntypedFormControl {
    return this.customFilterForm.controls.status as UntypedFormControl
  }
}
